import { AgRendererComponent } from 'ag-grid-angular';
import { ChangeDetectorRef, Component } from '@angular/core';
import { ColorService } from '@app/shared/services/color.service';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'acs-ag-grid-cell-order-num',
  styles: [
    `
      :host {
        display: flex;
      }
    `
  ],
  template: `
    @if (!useCellColorFill) {
      <mat-icon
        class="fa fa-circle m-1"
        [ngStyle]="{ color: iconColor ? iconColor : 'transparent' }"></mat-icon>
    }
    {{ params.value }}
  `,
  standalone: false
})
export class AgGridCellOrderNumComponent implements AgRendererComponent {
  public useCellColorFill = false;
  public params: ICellRendererParams;
  public iconColor: string;
  public textColor = 'inherit';

  constructor(
    private cdr: ChangeDetectorRef,
    private colorService: ColorService
  ) {}

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    this.useCellColorFill = !!this.params?.context?.componentParent?.useCellColorFill;

    let colorVal = 0;
    if (this.params.data.orderFlagId) {
      colorVal = this.params.data.orderFlagId;
    } else if (this.params.data.orderColorId) {
      colorVal = this.params.data.orderColorId;
    }

    const color = this.colorService.getColor(colorVal);

    if (color) {
      this.iconColor = color.hex;
      this.textColor = color.complementary;
    } else {
      this.iconColor = undefined;
      this.textColor = 'inherit';
    }

    this.applyGridCellColorFill();
  }

  public refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    this.cdr.detectChanges();
    return true;
  }

  private applyGridCellColorFill(): void {
    const gridCell = this.params?.eGridCell as HTMLElement;
    if (!gridCell) {
      return;
    }

    const shouldFillCell = this.useCellColorFill && !!this.iconColor;
    gridCell.style.backgroundColor = shouldFillCell ? this.iconColor : '';
    gridCell.style.color = shouldFillCell ? this.textColor : '';
  }
}
